import { create } from 'zustand';
import { SecurityInformationType } from 'typings/common.type';
import * as action from './action';
import {
  DailyChangesType,
  DataFiltersType,
  SecurityData,
  SummaryDataType,
} from 'typings/shareholders.type';

type ShareholdersType = {
  securityInfoData: SecurityInformationType;
  securityInfoLoading: boolean;
  securityInfoError: boolean;
  getSecurityInformationAction: (securityId: string) => void;
  deleteShareholdersTableDataAction: () => void;
  summaryData: SummaryDataType;
  summaryLoading: boolean;
  summaryError: boolean;
  getSummaryDataAction: (securityId: string) => void;
  securitySimpleData: SecurityData[];
  securitySimpleLoading: boolean;
  securitySimpleError: boolean;
  securityCombinedData: SecurityData[];
  securityCombinedLoading: boolean;
  securityCombinedError: boolean;
  dailyChangeSimpleData: DailyChangesType[];
  dailyChangeLoading: boolean;
  dailyChangeSimpleError: boolean;
  dailyChangeCombinedData: DailyChangesType[];
  dailyChangeCombinedError: boolean;
  getShareholdersTableDataAction: (
    securityId: string,
    isSimple: boolean,
  ) => void;
  securitiesDataFilters: DataFiltersType;
  dailyChangesDataFilters: DataFiltersType;
  getDailyChangeDataAction: (isSimple, shareholderName?) => void;
  deleteDailyChangesDataAction: () => void;
  saveShareholdersFilterAction: (value: DataFiltersType) => void;
  reset: () => void;
};

const initialState = {
  securityInfoData: null,
  securityInfoLoading: false,
  securityInfoError: false,
  summaryData: null,
  summaryLoading: false,
  summaryError: false,
  securitySimpleData: null,
  securitySimpleLoading: false,
  securitySimpleError: false,
  securityCombinedData: null,
  securityCombinedLoading: false,
  securityCombinedError: false,
  dailyChangeSimpleData: null,
  dailyChangeLoading: false,
  dailyChangeSimpleError: false,
  dailyChangeCombinedData: null,
  dailyChangeCombinedError: false,
  securitiesDataFilters: { isSimpleStatus: true },
  dailyChangesDataFilters: { individualFilter: 'all', isSimpleStatus: true },
};

const useShareholdersStore = create<ShareholdersType>((set) => ({
  ...initialState,
  reset: (): void => set(initialState),
  getSecurityInformationAction: (securityId: string): Promise<void> =>
    action.getSecurityInformationAction(set, securityId),
  deleteShareholdersTableDataAction: (): void =>
    action.deleteShareholdersTableDataAction(set),
  getSummaryDataAction: (securityId: string): Promise<void> =>
    action.getSummaryDataAction(set, securityId),
  getShareholdersTableDataAction: (
    securityId: string,
    isSimple: boolean,
  ): Promise<void> =>
    action.getShareholdersTableDataAction(set, securityId, isSimple),
  getDailyChangeDataAction: (
    isSimple: boolean,
    shareholderName?: string,
  ): Promise<void> =>
    action.getDailyChangeDataAction(set, isSimple, shareholderName),
  deleteDailyChangesDataAction: (): void =>
    action.deleteDailyChangesDataAction(set),
  saveShareholdersFilterAction: (body: DataFiltersType): void =>
    action.saveShareholdersFilterAction(set, body),
}));

export default useShareholdersStore;
